<template>
    <div class="app-container">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item>惠企政策</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>

        </el-row>

        <div class="search-where">
            <div class="search-item">
                <div class="search-item-left">
                    类型：
                </div>
                <div class="search-item-right">
                    <el-button class="item-right-select-ly" :class="{'font-blue':'all'==queryParams.patentType}" @click="handlePatentType('all')">不限</el-button>
                    <el-button class="item-right-select-ly" v-for="item in typeOptions" :class="{'font-blue':item.dictValue==queryParams.patentType}" @click="handlePatentType(item.dictValue)">
                        {{item.dictLabel}}
                    </el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="search-item">
                <div class="search-item-left">
                    业务类型：
                </div>
                <div class="search-item-right">
                    <el-button class="item-right-select-status" :class="{'font-blue':'all'==queryParams.patentBusinessType}" @click="handlePatentBusinessType('all')">不限</el-button>
                    <el-button class="item-right-select-status" v-for="item in businessTypeOptions" :class="{'font-blue':item.dictValue==queryParams.patentBusinessType}" @click="handlePatentBusinessType(item.dictValue)">
                        {{item.dictLabel}}
                    </el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="search-item">
                <div class="search-item-left">
                    区域：
                </div>
                <div class="search-item-right">
                    <el-button class="item-right-select-status" :class="{'font-blue':'all'==queryParams.patentRegion}" @click="handlePatentRegion('all')">不限</el-button>
                    <el-button class="item-right-select-status" v-for="item in regionOptions" :class="{'font-blue':item.dictValue==queryParams.patentRegion}" @click="handlePatentRegion(item.dictValue)">
                        {{item.dictLabel}}
                    </el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="search-item" style="width: 70%;">
                <div class="search-item-left">
                    搜索查询：
                </div>
                <div class="search-item-right">
                    <el-input placeholder="请输入标题/内容" v-model="queryParams.patentName" class="input-with-select" prefix-icon="el-icon-search">
                        <el-button slot="append" type="primary" @click="getList">搜索</el-button>
                    </el-input>
                </div>
            </div>
        </div>

        <div class="search-page">
            <div class="search-page-order">
                <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='zhpx'}" @click="handleOrder('zhpx')">综合排序</el-button>
                <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='ssrq'}" @click="handleOrder('ssrq')">
                    实施日期<i class="el-icon-bottom" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='ssrq'"></i>
                    <i class="el-icon-top" v-else></i>
                </el-button>
                <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='fbrq'}" @click="handleOrder('fbrq')">
                    发布日期<i class="el-icon-bottom" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='fbrq'"></i>
                    <i class="el-icon-top" v-else></i>
                </el-button>
            </div>
            <div class="search-page-page">
                <el-pagination class="pagination"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page.sync="queryParams.pageNum"
                               :page-size="queryParams.pageSize"
                               :hide-on-single-page="true"
                               layout="total, prev, pager, next"
                               :total="total"
                               @pagination="getList">
                </el-pagination>
            </div>
        </div>

        <div class="search-table">
            <el-table v-loading="loading" :data="list" >
                <el-table-column type="index" label="序号" align="center" width="100"></el-table-column>
                <el-table-column label="标题" header-align="center" align="center" prop="title" show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-link :underline="false" @click="openDetail(scope.row.recid)">{{ scope.row.title }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="区域" align="center" prop="patentRegion" :width="150" >
                    <template slot-scope="scope">
                        <span>{{dictFormatPatentRegion(scope.row.patentRegion)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="发布日期" align="center" prop="fbTime" :width="200" />
                <el-table-column label="实施日期" align="center" prop="ssTime" :width="200" />
            </el-table>
        </div>

    </div>
</template>

<script>
    import { listMarket } from "@/api/zscq/market";

    export default {
        name: "hqzc",
        data() {
            return {
                // 遮罩层
                loading: true,
                // 总条数
                total: 0,
                // 表格数据
                list: [],
                // 查询参数
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    patentBusinessType:"all",
                    patentType:'all',
                    patentRegion:"all",
                    orderBy:"zhpx",
                    isAsc:"asc",
                    patentName:undefined
                },
                patentStatusOptions:[],
                typeOptions:[],
                businessTypeOptions:[],
                regionOptions:[]
            };
        },
        created() {
            this.getDicts("yw_flfg_lx").then(response => {
                this.typeOptions = response.data;
            });
            this.getDicts("yw_flfg_ywlx").then(response => {
                this.businessTypeOptions = response.data;
            });
            this.getDicts("yw_flfg_qy").then(response => {
                this.regionOptions = response.data;
            });
            this.getList();
        },
        methods: {
            getList(){
                this.list=[];
                this.loading = true;
				this.list = [
					{recid:'1',title:'中华人民共和国专利法（2020修正）',patentRegion:'0',fbTime:'2021-10-01',ssTime:'2021-10-10'},
					{recid:'2',title:'中华人民共和国专利法（2020修正）',patentRegion:'1',fbTime:'2021-10-02',ssTime:'2021-10-11'},
					{recid:'3',title:'威海市市场监督管理局 威海市财政局关于印发《威海市市级专利申请报告》',patentRegion:'2',fbTime:'2021-10-03',ssTime:'2021-10-12'},
					{recid:'4',title:'中华人民共和国专利法（2020修正）',patentRegion:'0',fbTime:'2021-10-04',ssTime:'2021-10-13'},
					{recid:'5',title:'中华人民共和国专利法（2020修正）',patentRegion:'1',fbTime:'2021-10-05',ssTime:'2021-10-14'},
					{recid:'6',title:'威海市市场监督管理局 威海市财政局关于印发《威海市市级专利申请报告》',patentRegion:'2',fbTime:'2021-10-06',ssTime:'2021-10-15'},
				]
				this.total = 6;
				this.loading = false;
                /* listMarket(this.queryParams).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.loading = false;
                }); */
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.getList();
            },
            handlePatentType(code){
                this.queryParams.patentType=code;
                this.getList();
            },
            handlePatentBusinessType(code){
                this.queryParams.patentBusinessType=code;
                this.getList();
            },
            handlePatentRegion(code){
                this.queryParams.patentRegion=code;
                this.getList();
            },
            handleOrder(code){
                if(this.queryParams.orderBy==code){
                    // console.log(this.queryParams.isAsc);
                    if(this.queryParams.isAsc=="asc"){
                        this.queryParams.isAsc="desc";
                    }else{
                        this.queryParams.isAsc="asc";
                    }
                }
                if(code=="zhpx"){
                    this.queryParams.isAsc="asc";
                }
                this.queryParams.orderBy=code;
                this.getList();
            },
            /* openMarket(){
                this.$router.push({
                    path: '/main/zscqcsRecord'
                })
                this.$store.commit('SET_MAININDEX', '/main/zscqcs');
            }, */
            openDetail(recid){
                this.$router.push({
                    path: '/main/xwqyczfw/hqzcDetail/'+recid
                })
                this.$store.commit('SET_MAININDEX', '/main/hqzc');
            },
            dictFormatType(value) {
                return this.selectDictLabel(this.typeOptions, value) || '未知';
            },
            dictFormatPatentRegion(value) {
                return this.selectDictLabel(this.regionOptions, value) || '未知';
            },
            dictFormatLabelType(row, column, cellValue) {
                if (cellValue == undefined) {
                    return '-';
                }
                let values = cellValue.split(",");
                let text = '';
                for (let value of values) {
                    text = text + "," + this.selectDictLabel(this.labelTypeOptions, value);
                }
                text = text.substring(1, text.length);
                return text == '' ? '-' : text;
            }
        }
    }
</script>

<style scoped>
    .app-container{
        padding-bottom: 30px;
    }
    .search-where{
        margin: 10px 0px;
        padding: 15px;
        background-color: #ffffff;
    }
    .el-divider--horizontal{
        margin: 12px 0px;
    }
    .search-item{
        display: flex;
        /*border-bottom: 1px solid #000000;*/
    }
    .search-item-left{
        line-height: 40px;
        font-weight: bold;
    }
    .search-item-right{
        flex: 1;
        padding: 0px 10px;
    }
    .item-right-select-ly{
        float: left;
        /*width: 85px;*/
        padding: 5px 10px;
        line-height: 30px;
        /*border: 1px solid #000000;*/
    }
    .item-right-select-status{
        float: left;
        /*width: 110px;*/
        padding: 5px 20px;
        line-height: 30px;
    }
    .el-button{
        border: 0px;
    }
    .el-button+.el-button{
        margin-left: 0;
    }
    .el-input-group__append button.el-button{
        background-color:#4A8DEC;
        color: #ffffff;
    }
    /deep/.el-input--medium .el-input__inner{
        height: 40px;
        line-height: 40px;
    }
    .el-input-group__append .el-button--medium{
        padding: 13px 30px;
    }
    .search-item-zr{
        flex: 1;
        padding: 0px 100px 0px 0px;
        text-align: right;
    }
    .button-zr{
        height: 40px;
        line-height: 20px;
    }
    .search-page{
        margin: 0px 0px 10px;
        padding: 20px 15px;
        background-color: #ffffff;
        display: flex;
    }
    .search-page-order{
        display: flex;

    }
    .order-filed{
        flex: 1;
        padding: 0px 15px;
        color:#000000;
    }
    .search-page-page{
        flex: 1;
        text-align: right;
    }
    .search-table{
        margin: 0px;
        padding: 15px;
        background-color: #ffffff;
    }

    .danger-light {
        background-color: #F56C6C;
        padding: 5px 10px;
    }

    .warning-light {
        background-color: #E6A23C;
        padding: 5px 10px;
    }

    .success-light {
        background-color: #67C23A;
        padding: 5px 10px;
    }
    .font-success{
        color: #67C23A;
    }
    .font-danger{
        color: #F56C6C;
    }
    .font-warning{
        color: #e6a23c;
    }
    .font-blue{
        color: #409eff;
    }
    .search-item-right /deep/.el-button {
        background-color: #ffffff;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
</style>